var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6001_485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70959 0.9375V2.78592M12 0.9375V2.78592M17.2904 0.9375V2.78592M6.70959 21.2141V23.0625M12 21.2141V23.0625M17.2904 21.2141V23.0625M23.0625 6.70959H21.2141M23.0625 12H21.2141M2.78592 6.70959H0.9375M2.78592 12H0.9375M2.78592 17.2904H0.9375M7.30378 15.3497L9.78272 8.84091C9.83339 8.71706 10.0087 8.71688 10.0596 8.84063L12.516 15.3497M8.07689 13.7287H11.7554M16.3212 8.65031V15.252",
    stroke: "url(#paint0_linear_6001_485)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1005 14.5881V4.7122C22.1005 3.15891 20.8413 1.8997 19.288 1.8997H4.7124C3.15911 1.8997 1.8999 3.15891 1.8999 4.7122V19.2878C1.8999 20.8411 3.15911 22.1003 4.7124 22.1003H19.288C20.8413 22.1003 22.1005 20.8411 22.1005 19.2878V19.2756",
    stroke: "url(#paint1_linear_6001_485)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6001_485",
    x1: 0.815439,
    y1: 12.0001,
    x2: 23.1846,
    y2: 12.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6001_485",
    x1: 1.78846,
    y1: 12.0001,
    x2: 22.212,
    y2: 12.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6001_485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconColor);
export default __webpack_public_path__ + "static/media/ai_icon_color.186e34405deb08c185c15783dbf9b4af.svg";
export { ForwardRef as ReactComponent };